module.exports = __webpack_public_path__ + "static/media/sf_attraction_19.da409202.jpg";